<template>
  <div class="overlay">
    <!-- Method 1 -->
    <div class="report-modal" v-if="modal == 'report' && type == 'survey'">
      <div class="report-header">
        <h1 class="answer-report-title">Answers Report</h1>
      </div>
      <div class="report-body">
        <div class="report-item checkbox" v-for="(item, index) in report_data" :key="index">
          <h3 class="question-title">{{ index + 1 }}. {{ item.ask }}</h3>
          <apexchart width="400" type="polarArea" :options="item.chart_options" :series="item.chart_series"></apexchart>
        </div>
      </div>
      <div class="report-footer">
        <button @click="onCancel()" class="btn-close">Close</button>
      </div>
    </div>

    <!-- Method 2 -->
    <div class="users-answer-modal" v-if="modal == 'result' && type == 'survey'">
      <div class="users-answer-body">
        <div class="users-answer-body-left">
          <div class="users-answer-body-left-header">
            All Consultants ({{ value.answers.length }})
          </div>
          <div class="users-answer-body-left-body">
            <div class="user-item" v-for="(item, index) in value.answers" :key="index" :class="{ active: index == null }"
              @click="getUserResult(item)">
              <widgetProfile :title="`${item.student.first_name} ${item.student.last_name}`"
                :subtitle="item.student.email" :file_name="item.student.profile_picture"
                :path="$fullUrl('images/profiles/')"></widgetProfile>
            </div>
          </div>
        </div>
        <div class="users-answer-body-right" v-if="survey_result.length > 0">
          <div class="users-answer-body-right-header">Survey response</div>
          <div class="users-answer-body-right-body">
            <template v-for="(item, index) in survey_result">
              <div class="survey-answer-widget" :key="index" v-if="item.section_type == 'question'">
                <div class="survey-answer-header">
                  <h1>{{ item.ask }}</h1>
                </div>
                <!-- For short answer -->
                <div v-if="item.question_type == 'short_answer'" class="survey-answer-body">
                  {{ item.answer }}
                </div>
                <!-- For long answer -->
                <div v-if="item.question_type == 'paragraph'" class="survey-answer-body">
                  {{ item.answer }}
                </div>
                <!-- For radio answer -->
                <div v-if="item.question_type == 'multiple_choice'" class="survey-answer-body">
                  <div class="radio-item" v-for="(option, option_index) in item.choice_options" :key="option_index"
                    :class="{ active: item.answer == option.value }">
                    <span>{{ option.name }}</span>
                  </div>
                </div>
                <!-- For checkbox answer -->
                <div v-if="item.question_type == 'checkboxes'" class="survey-answer-body">
                  <div class="checkbox-item" v-for="(option, option_index) in item.choice_options" :key="option_index"
                    :class="{ active: option.value }">
                    <span>{{ option.name }}</span>
                  </div>
                </div>
                <!-- For checkbox answer -->
                <div v-if="item.question_type == 'dropdown'" class="survey-answer-body">
                  <div class="selected-item" v-for="(option, option_index) in item.choice_options" :key="option_index"
                    v-if="option.value == item.answer">
                    <span>{{ option.name }}</span>
                  </div>
                </div>
                <!-- For file upload answer -->
                <div v-if="item.question_type == 'file_upload'" class="survey-answer-body">
                  <div class="uploaded-file-item">
                    <img v-if="$isImage(item.file_name)" :src="$fullUrl('images/' + item.file_name)" width="100%" />
                    <video v-if="$isVideo(item.file_name)" :src="$fullUrl('images/' + item.file_name)" width="100%" />
                    <a v-if="!$isVideo(item.file_name) && !$isImage(item.file_name)
                      " :download="$fullUrl('images/' + item.file_name)" class="btn-download"
                      :href="$fullUrl('images/' + item.file_name)">Download file</a>
                  </div>
                </div>
                <!-- For date answer -->
                <div v-if="item.question_type == 'date'" class="survey-answer-body">
                  <div class="date-item">
                    {{ item.answer | formatDate }}
                  </div>
                </div>
                <!-- For date answer -->
                <div v-if="item.question_type == 'time'" class="survey-answer-body">
                  <div class="date-item">
                    {{ item.answer }}
                  </div>
                </div>
              </div>
              <div class="survey-answer-widget" :class="{ section_widget: item.section_type == 'section' }" :key="index"
                v-if="item.section_type == 'section'" @click="selectSurvey(item)">
                <h1>{{ item.title }}</h1>
                <p>{{ item.description }}</p>
              </div>
              <div class="survey-answer-widget" :class="{ title_widget: item.section_type == 'title' }" :key="index"
                v-if="item.section_type == 'title'">
                <h2>{{ item.title }}</h2>
                <p>{{ item.description }}</p>
              </div>
            </template>
          </div>
        </div>
        <div class="users-answer-body-right" v-else></div>
      </div>
      <div class="users-answer-footer">
        <widgetButton @click="onCancel()" class="btn-secondary">
          Close
        </widgetButton>
      </div>
    </div>
    <!-- Method 3 -->
    <div class="question-answer-modal" v-if="modal == 'anonymous' && type == 'evaluation'">
      <div class="users-answer-header">
        <h1>{{ value.title }}</h1>

        <div class="users-answer-search-widget">
          <widgetSearch v-model="filter_form.query" placeholder="Search here" icon="right" @keyup="onSearchResult">
          </widgetSearch>
        </div>
      </div>
      <div class="question-widget">
        <div class="question-dropdown">
          <widgetDropdown v-model="question_dropdown" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              <span v-if="selected_question">{{ selected_question.ask }}</span>
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="question-dropdown-widget dropdown-widget left">
              <a class="dropdown-item" href="#" v-for="(item, index) in questions" :key="index"
                @click="selectQuestion(item)">
                {{ index + 1 }}. {{ item.ask }}</a>
            </div>
          </widgetDropdown>
        </div>
        <div class="question-options">
          <widgetButton v-if="!show_grath" class="btn-secondary" @click="show_grath = true">
            Generate graph
          </widgetButton>
          <widgetButton v-else class="btn-secondary" @click="show_grath = false">
            Back
          </widgetButton>
        </div>
      </div>
      <div v-if="!show_grath" class="users-answer-body">
        <div class="question-colmun" v-for="(item, index) in answers" :key="index" :class="{}">
          <div class="question-colmun-header" :title="item.answer">
            <div class="answer">{{ item.answer }} ({{ item.count }})</div>
            <div class="parcent">{{ parseInt(item.percentage) }}%</div>
          </div>
          <div class="question-colmun-body">
            <div class="user-item" v-for="(student, index) in item.consultants" :key="index">
              <widgetProfile :title="`${student.first_name} ${student.last_name}`" :file_name="student.profile_picture"
                :path="$fullUrl('images/profiles/')"></widgetProfile>
            </div>
          </div>
        </div>
      </div>
      <div v-if="show_grath" class="users-answer-body center-chart">
        <apexchart v-if="answer_chart_series && answer_chart_series" width="500" height="500" type="pie"
          :options="answer_chart_options" :series="answer_chart_series"></apexchart>
      </div>
      <div class="users-answer-footer">
        <widgetButton @click="onCancel()" class="btn-secondary">
          Close
        </widgetButton>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: "",
    },
    modal: {
      type: String,
      default: "report",
    },
  },
  data: () => {
    return {
      report_data: [],
      series_bar: [
        {
          name: "Actual",
          data: [
            {
              x: "2011",
              y: 12,
              goals: [
                {
                  name: "Expected",
                  value: 14,
                  strokeWidth: 5,
                  strokeColor: "#775DD0",
                },
              ],
            },
            {
              x: "2012",
              y: 44,
              goals: [
                {
                  name: "Expected",
                  value: 54,
                  strokeWidth: 5,
                  strokeColor: "#775DD0",
                },
              ],
            },
            {
              x: "2013",
              y: 54,
              goals: [
                {
                  name: "Expected",
                  value: 52,
                  strokeWidth: 5,
                  strokeColor: "#775DD0",
                },
              ],
            },
            {
              x: "2014",
              y: 66,
              goals: [
                {
                  name: "Expected",
                  value: 65,
                  strokeWidth: 5,
                  strokeColor: "#775DD0",
                },
              ],
            },
            {
              x: "2015",
              y: 81,
              goals: [
                {
                  name: "Expected",
                  value: 66,
                  strokeWidth: 5,
                  strokeColor: "#775DD0",
                },
              ],
            },
            {
              x: "2016",
              y: 67,
              goals: [
                {
                  name: "Expected",
                  value: 70,
                  strokeWidth: 5,
                  strokeColor: "#775DD0",
                },
              ],
            },
          ],
        },
      ],
      chartOptions_bar: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ["#00E396"],
        dataLabels: {
          formatter: function (val, opt) {
            const goals =
              opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                .goals;

            if (goals && goals.length) {
              return `${val} / ${goals[0].value}`;
            }
            return val;
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Actual", "Expected"],
          position: "bottom",
          markers: {
            fillColors: ["#00E396", "#775DD0"],
          },
        },
      },
      survey_result: [],
      isLoading: false,
      question_dropdown: false,
      questions: [],
      answers: [],
      selected_question: null,
      answer_chart_options: null,
      answer_chart_series: null,
      show_grath: false,
      filter_form: {
        form_id: null,
        question: "",
        query: "",
        answers: "",
      },
    };
  },
  mounted() {
    let vm = this;
    if (vm.value && vm.modal == "anonymous") {
      vm.getQuestions(vm.value);
    }
  },
  computed: {},
  watch: {},
  methods: {
    onSearchResult({ target }) {
      let vm = this;
      vm.selectQuestion(vm.selected_question);
    },
    selectQuestion(item) {
      let vm = this;
      vm.selected_question = item;
      vm.question_dropdown = false;
      vm.isLoading = true;
      vm.filter_form.form_id = vm.value.id;
      vm.filter_form.question = item.ask;
      vm.filter_form.answers = item.choice_options;
      vm.$store
        .dispatch("COMMUNICATION_GET_QUESTION_ANSWERS", vm.filter_form)
        .then((responce) => {
          vm.isLoading = false;
          vm.answers = responce.data;
          vm.loadAnswerChart();
        })
        .catch((error) => {
          vm.isLoading = false;
          vm.loadAnswerChart(null);
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    loadAnswerChart() {
      let vm = this;
      let series = [];
      let labels = [];
      vm.answers.forEach((item, index) => {
        series.push(item.count);
        labels.push(item.answer);
      });
      let chart_options = {
        labels: labels,
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "bottom",
        },
        tooltip: {
          enabled: true,
        },
        chart: {
          type: "pie",
        },
        stroke: {
          colors: ["#fff"],
        },
        fill: {
          opacity: 0.8,
        },
        yaxis: {
          show: false,
          labels: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
      vm.answer_chart_options = chart_options;
      vm.answer_chart_series = series;
    },
    getQuestions(item) {
      let vm = this;
      vm.questions = JSON.parse(item.question).filter(
        (item) =>
          item.question_type == "multiple_choice" ||
          item.question_type == "checkboxes" ||
          item.question_type == "dropdown"
      );
      if (vm.questions.length > 0) {
        vm.selectQuestion(vm.questions[0]);
      }
    },
    getUserResult(item) {
      let vm = this;
      vm.survey_result = item.answer;
      //vm.isLoading = true;
      // vm.$store
      //   .dispatch("INSTRUCTOR_SCHOOL_VIEW_SURVEY_RESULT", {
      //     user_id: user.id,
      //     survey_id: vm.value.id,
      //     type: vm.type,
      //   })
      //   .then((responce) => {
      //     vm.isLoading = false;
      //     if (responce.data.answer) {
      //       vm.survey_result = JSON.parse(responce.data.answer);
      //     } else {
      //       vm.survey_result = [];
      //       vm.$notify({
      //         group: "status",
      //         title: "Success",
      //         text: "Something went wrong, try again",
      //         type: "warn",
      //         duration: 3000,
      //       });
      //       vm.onCancel();
      //     }
      //   })
      //   .catch((error) => {
      //     vm.isLoading = false;
      //     vm.$notify({
      //       group: "status",
      //       title: "Success",
      //       text: "Something went wrong, try again",
      //       type: "warn",
      //       duration: 3000,
      //     });
      //   });
    },
    loadReport(item) {
      let vm = this;
      vm.show_report_modal = true;
      vm.$store
        .dispatch("PROCESSMESSAGE_SURVEY_REPORT", { id: item.id })
        .then((responce) => {
          vm.report_data = responce.data.map((item) => {
            let keys = Object.keys(item.answers);
            let series = [];
            let labels = [];
            keys.forEach((key, i) => {
              let k = Object.keys(item.answers[key])[0];
              let v = parseInt(item.answers[key][k]);
              series.push(v);
              labels.push(k);
            });
            let chart_options = {
              labels: labels,
              legend: {
                show: true,
              },
              tooltip: {
                enabled: true,
              },
              chart: {
                type: "pie",
              },
              stroke: {
                colors: ["#fff"],
              },
              fill: {
                opacity: 0.8,
              },
              yaxis: {
                show: false,
                labels: {
                  show: false,
                },
                tooltip: {
                  enabled: false,
                },
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200,
                    },
                    legend: {
                      position: "bottom",
                    },
                  },
                },
              ],
            };
            eventBus.$set(item, "chart_series", series);
            eventBus.$set(item, "chart_options", chart_options);
            return item;
          });
        })
        .catch((error) => { });
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
    $isVideo(filename) {
      return /\.(webm|mp4|mkv)$/i.test(filename);
    },
    $isImage(filename) {
      return /\.(jpeg|jpe|jpg|gif|png|webp|svg)$/i.test(filename);
    },
  },
};
</script>
<style lang="scss">
.question-dropdown-widget {
  height: 400px;
  width: 500px;
  overflow-y: scroll;
}
</style>
<style lang="scss" scoped>
$assets: "~@/assets";

.overlay {
  .report-modal {
    width: 850px;
    height: 750px;
    background: #fff;
    min-height: 400px;
    border-radius: 10px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .report-header {
      height: 70px;
      display: flex;
      align-items: center;
      padding: 0px 30px;

      .answer-report-title {
        font-size: 20px;
      }
    }

    .report-body {
      height: calc(100% - 140px);
      overflow-y: auto;
      padding: 0px 30px;

      .report-item {
        .question-title {
          font-size: 16px;
        }

        &.checkbox {}

        .radio-report-widget {
          display: flex;
          width: 500px;

          .radion-item {
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;

            label {
              color: #fff;
            }
          }
        }

        .radio-report-legend {
          display: flex;
          margin-top: 10px;

          .legend-item {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .legend-circle {
              height: 15px;
              width: 15px;
              border-radius: 50%;
              background: #1ba5a4;
              margin-right: 5px;
            }

            label {
              color: #1ba5a4;
            }
          }
        }
      }
    }

    .report-footer {
      padding: 0px 30px;
      height: 70px;
      display: flex;
      align-items: center;

      .btn-close {
        width: 220px;
        height: 47px;
        background: #0884af;
        border-radius: 5px;
        color: #fff;
      }
    }
  }

  .users-answer-modal {
    width: 1000px;
    height: 750px;
    background: #fff;
    border-radius: 10px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .users-answer-body {
      height: calc(100% - 70px);
      display: flex;

      .users-answer-body-left {
        height: 100%;
        display: flex;
        flex-direction: column;
        border-right: 1px solid #ddd;
        width: 300px;

        .users-answer-body-left-header {
          height: 60px;
          display: flex;
          align-items: center;
          padding: 0px 15px;
          font-size: 19px;
        }

        .users-answer-body-left-body {
          overflow-y: auto;
          height: calc(100% - 60px);

          .user-item {
            padding: 10px 15px;
            cursor: pointer;

            &.active {
              background: #f5f5f5;
            }

            &:hover {
              background: #f5f5f5;
            }
          }
        }
      }

      .users-answer-body-right {
        height: 100%;
        display: flex;
        flex-direction: column;
        width: calc(100% - 300px);

        .users-answer-body-right-header {
          height: 60px;
          display: flex;
          align-items: center;
          padding: 0px 15px;
          font-size: 19px;
        }

        .users-answer-body-right-body {
          overflow-y: auto;
          height: calc(100% - 60px);
          padding: 0px 15px;

          .survey-answer-widget {
            border-bottom: 1px solid #ddd;
            margin-bottom: 20px;

            &.section_widget {
              border-bottom: 3px solid #ddd;

              h1 {
                font-size: 20px;
              }
            }

            &.title_widget {
              h2 {
                font-size: 18px;
              }

              p {
                font-size: 13px;
              }
            }

            .survey-answer-header {
              h1 {
                font-size: 16px;
                color: #000;
              }
            }

            .survey-answer-body {
              color: rgb(43, 42, 42);

              .radio-item {
                margin-bottom: 6px;

                &.active {
                  color: #0884af;
                  padding: 4px;
                  border-left: 3px solid #0884af;
                }
              }

              .checkbox-item {
                margin-bottom: 6px;

                &.active {
                  color: #0884af;
                  padding: 4px;
                  border-left: 3px solid #0884af;
                }
              }

              .uploaded-file-item {
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;

                .btn-download {
                  background: #0884af;
                  color: #fff;
                  padding: 11px;
                  border-radius: 5px;
                  text-decoration: none;
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }

    .users-answer-footer {
      padding: 0px 20px;
      height: 70px;
      display: flex;
      align-items: center;
    }
  }

  .question-answer-modal {
    max-width: 1000px;
    height: 690px;
    background: #fff;
    border-radius: 10px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .users-answer-header {
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 15px;

      h1 {
        font-size: 17px;
      }
    }

    .question-widget {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      padding: 0px 15px;

      .question-dropdown {
        .btn-dropdown {
          span {
            max-width: 500px;
            overflow: hidden;
            text-decoration: none;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .users-answer-body {
      height: calc(100% - 190px);
      display: flex;
      overflow-y: auto;
      padding: 0px 15px;

      &.center-chart {
        justify-content: center;
        padding-top: 80px;
      }

      .question-colmun {
        width: 500px;
        height: 100%;
        display: flex;
        flex-direction: column;

        .question-colmun-header {
          height: 60px;
          padding: 0px 15px;
          display: flex;
          align-items: center;
          justify-content: center;

          .answer {
            font-size: 15px;
            padding-right: 20px;
            overflow: hidden;
            text-decoration: none;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 200px;
          }

          .parcent {
            font-size: 15px;
            font-weight: 800;
          }
        }

        .question-colmun-body {
          height: calc(100% - 60px);
          padding: 0px 15px;
          overflow-y: auto;
          padding-top: 10px;

          .user-item {
            margin-bottom: 10px;
          }
        }
      }

      .question-colmun:first-child {
        .question-colmun-header {
          border-bottom-left-radius: 10px;
          border-top-left-radius: 10px;
        }
      }

      .question-colmun:last-child {
        .question-colmun-header {
          border-bottom-right-radius: 10px;
          border-top-right-radius: 10px;
        }
      }

      .question-colmun:nth-child(odd) {
        .question-colmun-header {
          background: #c3c3c3;
        }

        .question-colmun-body {
          background: #fff;
        }
      }

      .question-colmun:nth-child(even) {
        background: #f5f5f5;

        .question-colmun-header {
          background: #e4e4e4;
        }
      }
    }

    .users-answer-footer {
      padding: 0px 20px;
      height: 70px;
      display: flex;
      align-items: center;
    }
  }
}
</style>


